// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TUEk","title":"styles_title__2MizG"};